import { useHoliday } from "../../../contexts/HolidayContext";
import { Table, TableBody, TableRow, TableCell } from "../../../design/table";
import { Text } from "../../../design/text";
import { Holiday } from "../../../models/Holiday";

interface Props {
  onSelect: (holiday: Holiday) => void;
}

const ChooseHolidayStep: React.FC<Props> = ({ onSelect }) => {
  const { holidays } = useHoliday();

  const sortedHolidays = holidays.sort((a, b) => {
    const aDate = new Date(a.dates[0]);
    const bDate = new Date(b.dates[0]);
    return aDate.getTime() - bDate.getTime();
  });

  return (
    <Table>
      <TableBody>
        {sortedHolidays.map((holiday) => (
          <TableRow key={holiday._id} onClick={() => onSelect(holiday)}>
            <TableCell className="font-medium">
              {holiday.name}
              {holiday.description && (
                <Text className="text-sm">{holiday.description}</Text>
              )}
            </TableCell>
            <TableCell className="text-center">
              {holiday.dates[0] &&
                new Date(holiday.dates[0]).toLocaleDateString()}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ChooseHolidayStep;
